import {request, _urlVacancy} from "../api";
import {VACANCY_CONSTS} from "../constants";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";

export const GetVacancies = () => {
    const requestData = {
        url: _urlVacancy,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: VACANCY_CONSTS.GET_VACANCIES,
                    payload: data
                });
            })
    }
};

export const GetVacancyById = (id) => {
    const requestData = {
        url: `${_urlVacancy}/${id}`,
        token: true,
        method: "GET",
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: VACANCY_CONSTS.GET_VACANCIES_BY_ID,
                    payload: res.data
                })
            })
    }
};


export const DeleteVacancyById = id => {
    const requestData = {
        url:  `${_urlVacancy}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: VACANCY_CONSTS.DELETE_VACANCY_BY_ID,
                    payload: id
                });
            })
            .catch(() => {})
    }
};

export const CreateVacancy = data => {
    const requestData = {
        url: _urlVacancy,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: VACANCY_CONSTS.CREATE_VACANCY,
                    payload: res.data
                });
                notificationSuccess({
                    description: "Հաստիքը հաջողությամբ ստեղծվեց!"
                })
                history.push('/vacancy')
            })
            .catch(() => {
            })
    }
};

export const UpdateVacancyById = (id, data) => {
    const requestData = {
        url: `${_urlVacancy}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: VACANCY_CONSTS.UPDATE_VACANCY_BY_ID,
                    payload: res.data
                });
                notificationSuccess({
                    description: "Հաստիքը հաջողությամբ փոփոխվեց!"
                })
                history.push('/vacancy')
            })
            .catch(() => {
            })
    }
};

export const UpdateVacanciesPositions = items => {
    const requestData = {
        url: _urlVacancy,
        token: true,
        method: "PUT",
        data: items
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: VACANCY_CONSTS.UPDATE_VACANCIES_POSITIONS
                });
                notificationSuccess({
                    description: "Հաստիքը հաջողությամբ թարմացվեց!"
                })
            })
            .catch(() => {
            })
    }
};
